import { getText } from "oolib";
import { __GetContentTypeConfigNew } from "../getters/gettersV2";

export const fn = ({
  content,
  prevLoc,
  allProfileTpls,
}) => {
  const {
    main: { title, kp_title } = {},
    meta: { kp_content_type: contentType, caseNumber },
  } = content;
  const thisContentTypeConfig = __GetContentTypeConfigNew(contentType)

  const contentTypeTitle = thisContentTypeConfig.general.content?.title;
  const listingPageEnable = thisContentTypeConfig.listing?.enable

  switch (true) {
    // direct land on pbl page via link
    case contentType === "staticPages":
      return undefined;
    case !prevLoc || !prevLoc[0]:
      return [
        //DB > PBL LIST > PBL PG
        { display: "My Dashboard", to: "/" },
        ...( listingPageEnable ? [{
          display: `${contentTypeTitle} Listing`,
          to: `/published-listing/${contentType}`,
        }] : []),
        { display: getText([title, kp_title, caseNumber]) },
      ];
    case prevLoc[0].pathname.includes("published-listing"):
      return [
        { display: "My Dashboard", to: "/" },
        {
          display: `${contentTypeTitle} Listing`,
          to: `/published-listing/${contentType}`,
        },
        { display: getText([title, kp_title, caseNumber]) },
      ];
    case prevLoc[0].pathname.includes("profile/userProfiles"):
      // return 'DB > PROFILE LIST > PROFILE LAND'
      let profileType = prevLoc[0].pathname.split("/").filter(Boolean)[2];
      let { title: profileTypeTitle, singular: PTSingular } =
      allProfileTpls.find((d) => d.kp_content_type === profileType)?.general?.content || {};

      return [
        { display: "My Dashboard", to: "/" },
        {
          display: `${profileTypeTitle} Listing`,
          to: `/community-listing/${profileType}`,
        },
        { display: `${prevLoc[0].display} (${PTSingular})`, to: prevLoc[0] },
        { display: getText([title, kp_title, caseNumber]) },
      ];

    case prevLoc[0].pathname.includes("profile/groups"):
      // return 'DB > PROFILE LIST > PROFILE LAND'
      let groupProfileType = prevLoc[0].pathname.split("/").filter(Boolean)[2];
      let { title: groupTitle, singular: groupTSingular } =
        allProfileTpls.find((d) => d.kp_content_type === groupProfileType)?.general?.content || {};

      return [
        { display: "My Dashboard", to: "/" },
        {
          display: `${groupTitle} Listing`,
          to: `/community-listing/${groupProfileType}`,
        },
        { display: `${prevLoc[0].display} (${groupTSingular})`, to: prevLoc[0] },
        { display: getText([title, kp_title, caseNumber]) },
      ];
  

    
    case prevLoc[0].pathname.includes("MyContent"):
      return [
        { display: "My Dashboard", to: "/" },
        { display: "My Content", to: prevLoc[0] },
        { display: getText([title, kp_title, caseNumber]) },
      ];

    // pending : , orgs
    // pending participant manager redirect
    default:
      return undefined;
  }
};
